import { HgSelectOptions } from '@smg-real-estate/domus';
import { ComposerTranslation } from 'vue-i18n';

export enum EmploymentStatus {
  EMPLOYEE = 'Employee',
  TEMPORARY_EMPLOYEE = 'TemporaryEmployee',
  SELF_EMPLOYED = 'SelfEmployed',
  STUDENT = 'Student',
  HOUSEMAKER = 'Housemaker',
  RETIREE = 'Retiree',
  JOB_SEEKER = 'JobSeeker',
  OTHER = 'Other',
}

export const generateEmploymentStatusSelectOptions = (
  t: ComposerTranslation,
): HgSelectOptions[] => {
  return [
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.defaultOption').toString(),
      value: '',
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option1').toString(),
      value: EmploymentStatus.EMPLOYEE,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option2').toString(),
      value: EmploymentStatus.TEMPORARY_EMPLOYEE,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option3').toString(),
      value: EmploymentStatus.SELF_EMPLOYED,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option4').toString(),
      value: EmploymentStatus.STUDENT,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option5').toString(),
      value: EmploymentStatus.HOUSEMAKER,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option6').toString(),
      value: EmploymentStatus.RETIREE,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option7').toString(),
      value: EmploymentStatus.JOB_SEEKER,
    },
    {
      text: t('contactForm.leadQualification.buy.employmentStatus.option8').toString(),
      value: EmploymentStatus.OTHER,
    },
  ];
};
